<template>
  <div>
    <v-icon
      @click="$router.replace({name:'homepage'})"
    >
      mdi-home
    </v-icon>
    Ověření proběhlo úspěšně
  </div>
</template>

<script>
export default {
  name: 'VerificationSuccess'
}
</script>

<style scoped>

</style>
